import { PencilInBoxIcon } from "@8x8/oxygen-icon";
import { flexRender } from "@tanstack/react-table";
import { memo, useCallback, useState } from "react";
import { KEY } from "@/react/components/table/useTableMutations";
import { MarginLeftButton } from "@/react/features/smp/licenses/components/styled";
import styled, { css } from "styled-components";

const MarginLeftSpan = styled.span`
  margin-left: 8px;
`;

const ColumnSetterContainer = styled.div`
  display: flex;
  align-items: center;
  ${({ withMargin }) =>
    withMargin &&
    css`
      margin-bottom: 16px;
    `};
`;

const ColumnSetter = ({ column, table, rows }) => {
  const { schema, updateRows } = table.options.meta;
  const editableColumn = column.columnDef.editableColumn;
  const columnId = column.id;
  const firstValue = rows[0]?.getValue(columnId);

  const [value, setValue] = useState(firstValue);

  const getValue = useCallback(() => {
    return value;
  }, [value]);

  const onSet = useCallback(() => {
    const rowKeys = rows.map((row) => row.original[KEY]);
    updateRows(rowKeys, new Map([[columnId, value]]), schema);
  }, [value, rows, columnId, updateRows, schema]);

  return (
    <>
      <ColumnSetterContainer withMargin>
        <PencilInBoxIcon size={18} />
        <MarginLeftSpan>
          Set value for{" "}
          <span>
            {rows.length} {rows.length === 1 ? "row" : "rows"}
          </span>
        </MarginLeftSpan>
      </ColumnSetterContainer>
      <ColumnSetterContainer>
        {flexRender(editableColumn, {
          getValue,
          column,
          table,
          onChange: setValue,
        })}
        <MarginLeftButton variant="primary" size="small" onClick={onSet}>
          Set
        </MarginLeftButton>
      </ColumnSetterContainer>
    </>
  );
};

export default memo(ColumnSetter);
